import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

const STATUS_CLASSES: Record<string, string> = {
  DRAFT: "bg-zinc-500/10 text-zinc-400 border-zinc-500/20",
  PENDING_REVIEW: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  APPROVED: "bg-green-500/10 text-green-400 border-green-500/20",
  REJECTED: "bg-red-500/10 text-red-400 border-red-500/20",
  SCHEDULED: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  PUBLISHED: "bg-purple-500/10 text-purple-400 border-purple-500/20",
  FAILED: "bg-red-500/10 text-red-400 border-red-500/20",
};

export function StatusBadge({ status, className }: { status: string; className?: string }) {
  const { t } = useTranslation("common");
  const statusClass = STATUS_CLASSES[status] ?? "";
  const label = STATUS_CLASSES[status] !== undefined ? t(`status.${status}`) : status;
  return (
    <Badge variant="outline" className={cn(statusClass, className)}>
      {label}
    </Badge>
  );
}
